import React from 'react'

import styled from '@emotion/styled'
import { mq, text } from '../../_style'

const Container = styled.h2`
  ${text('36px', 58 / 36)}
  letter-spacing: 0.125em;
  font-feature-settings: "palt";
  ${mq.sp} {
    ${text('31px', 92 / 62)}
    letter-spacing: 0.05em;
  }
`
export default class Heading extends React.Component {
  render() {
    return(
      <Container>
        <span>{this.props.children}</span>
      </Container>
    )
  }
}
